import { render, staticRenderFns } from "./TransferBtn.vue?vue&type=template&id=e835e052&"
import script from "./TransferBtn.vue?vue&type=script&lang=js&"
export * from "./TransferBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports